import { render, staticRenderFns } from "./TabsRight.vue?vue&type=template&id=9bc35586&scoped=true"
import script from "./TabsRight.vue?vue&type=script&lang=js"
export * from "./TabsRight.vue?vue&type=script&lang=js"
import style0 from "./TabsRight.vue?vue&type=style&index=0&id=9bc35586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc35586",
  null
  
)

export default component.exports